import { Component, OnInit } from "@angular/core";
import { PostCount } from "../../models/post-count";
import { Observable } from "rxjs/Observable";
import { MetadataService } from "../../metadata.service";

@Component({
  selector: "meta-metrics",
  templateUrl: "./meta-metrics.component.html",
  styleUrls: ["./meta-metrics.component.css"]
})
export class MetaMetricsComponent implements OnInit {
  timezoneCode: string;
  postCount: Observable<PostCount[]>;
  postCountData: any[];
  postCountLabels: string[];
  chartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  hourPostData: Observable<PostCount[]>;
  hourPostCountData: any[];
  hourPostCountLabels: string[];
  hourChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };

  constructor(private service: MetadataService) {}

  ngOnInit() {
    this.timezoneCode = new Date()
      .toLocaleTimeString("en-us", { timeZoneName: "short" })
      .split(" ")[2];
    this.postCount = this.service.getDailyPostCount();
    this.hourPostData = this.service.getHourPostCount();
    this.postCount.subscribe(posts => this.setupDailyChart(posts));
    this.hourPostData.subscribe(hours => this.setupHourlyChart(hours));
  }

  setupDailyChart(posts: PostCount[]) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];

    this.postCountData = [
      {
        data: posts.map(post => post.count),
        backgroundColor: "rgba(8,178, 227, 0.5)",
        hoverBackgroundColor: "rgba(8,178, 227, 0.9)"
      }
    ];
    this.postCountLabels = posts.map(
      post => days[new Date(post.date).getDay()]
    );
    // console.log(this.postCountData);
    // console.log(this.postCountLabels);
  }

  setupHourlyChart(posts: PostCount[]) {
    var offset = new Date().getTimezoneOffset() / 60;
    // console.log(posts)
    // posts.map(post => console.log(post))
    posts.map(post => (post.hour = (post.hour - offset + 24) % 24));
    posts.sort((a, b) => a.hour - b.hour);
    // posts.map(post => console.log(post))
    this.hourPostCountData = [
      {
        data: posts.map(post => post.count),
        backgroundColor: "rgba(87,167,115, 0.5)",
        hoverBackgroundColor: "rgba(87,167,115, 0.9)"
      }
    ];
    this.hourPostCountLabels = posts.map(post => {
      switch (post.hour) {
        case 0:
          return "Midnight";
        case 3:
        case 6:
        case 9:
          return `${post.hour}:00 AM`;
        case 12:
          return "Noon";
        case 15:
        case 18:
        case 21:
          return `${post.hour % 12}:00 PM`;
        default:
          return "";
      }
    });
  }

  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/home/meta-metrics/meta-metrics.component.ts